import 'angular:locale/data:es-MX';
import 'angular:locale/data:en-US';
import 'angular:locale/data:en';
import './src/polyfills.ts';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
